export default __webpack_public_path__ + "static/media/activate_payment_desktop.59643c19.svg";